import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const libraries = ['places']; // Add more if needed

const GoogleMapsContext = createContext({
  google: null,
  isLoaded: false
});

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    libraries
  });

  return (
    <GoogleMapsContext.Provider value={{ google: isLoaded ? window.google : null, isLoaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);
